
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migracja-numeru/migracja-niemozliwa",
      function () {
        return require("private-next-pages/migracja-numeru/migracja-niemozliwa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migracja-numeru/migracja-niemozliwa"])
      });
    }
  